var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16 328h480v80h-480z",
    fill: "#1a6fb0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 408,
    fill: "#57565c",
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 408,
    fill: "#57565c",
    r: 48
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e0e2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 408,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 408,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 320v8h-480v-104a48 48 0 0 1 48-48h348.81a48 48 0 0 1 43.86 28.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 352h16a8 8 0 0 1 8 8v8a8 8 0 0 1 -8 8h-16a0 0 0 0 1 0 0v-24a0 0 0 0 1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 352h24a0 0 0 0 1 0 0v24a0 0 0 0 1 0 0h-24a8 8 0 0 1 -8-8v-8a8 8 0 0 1 8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m136 208h192v80h-192z",
    fill: "#00ccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.86 208h-97.86v80h125.1",
    fill: "#00ccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.1 207h84.9v81h-88",
    fill: "#00ccb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464 152h-424v-24h408z",
    fill: "#ffda44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m112 128h-40l-8-48a48 48 0 0 1 48 48z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152 80h80v48h-80z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 56h32v24h-32z",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 80h80v48h-80z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 56h32v24h-32z",
    fill: "#e0e0e2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392 384a24 24 0 1 0 24 24 24.027 24.027 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104 384a24 24 0 1 0 24 24 24.027 24.027 0 0 0 -24-24zm0 32a8 8 0 1 1 8-8 8.009 8.009 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.57 317.42-38.07-111.8v-.01l-1.26-3.68c-.08-.23-.16-.45-.26-.67a56.044 56.044 0 0 0 -51.17-33.26h-52.81v-8h104a8.009 8.009 0 0 0 6.66-12.44l-16-24a8.033 8.033 0 0 0 -6.66-3.56h-128v-40a8 8 0 0 0 -8-8h-16v-16a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v16h-32v-16a8 8 0 0 0 -8-8h-32a8 8 0 0 0 -8 8v16h-16a8 8 0 0 0 -8 8v40h-24.58a56.086 56.086 0 0 0 -55.42-48 8 8 0 0 0 -7.89 9.31l6.45 38.69h-22.56a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h72v8h-48a56.092 56.092 0 0 0 -52.15 35.63 6.691 6.691 0 0 0 -.39 1 55.569 55.569 0 0 0 -3.46 19.37v184a8 8 0 0 0 8 8h32.58a55.914 55.914 0 0 0 16.28 32h-48.86a8 8 0 0 0 0 16h448a8 8 0 0 0 0-16h-32.86a55.914 55.914 0 0 0 16.28-32h48.58a8 8 0 0 0 8-8v-88a7.8 7.8 0 0 0 -.43-2.58zm-29.64-37.42h-105.93v-64h84.13zm-209.93-216h16v8h-16zm-24 24h64v32h-64zm-56-24h16v8h-16zm-24 24h64v32h-64zm-56.8 32h-24.42l-5.14-30.83a40.154 40.154 0 0 1 29.56 30.83zm-55.2 24v-8h395.72l5.33 8zm296 16v8h-216v-8zm-320 64a40.44 40.44 0 0 1 1.03-9h70.97v65h-72zm0 72h80a8 8 0 0 0 8-8v-81a8 8 0 0 0 -8-8h-71.19a39.928 39.928 0 0 1 31.19-15h348.81a40.023 40.023 0 0 1 31.99 16h-84.8a8 8 0 0 0 -8 8v80a8 8 0 0 0 8 8h119.38l8.17 24h-463.55zm0 64h8l.01 8h-8.01zm80 88a40 40 0 1 1 40-40 40.04 40.04 0 0 1 -40 40zm39.14 0a55.914 55.914 0 0 0 16.28-32h177.16a55.914 55.914 0 0 0 16.28 32zm248.86 0a40 40 0 1 1 40-40 40.04 40.04 0 0 1 -40 40zm96-80h-16v-8h16zm0-24h-16a16.021 16.021 0 0 0 -16 16v8a16.021 16.021 0 0 0 16 16h16v16h-40.58a55.994 55.994 0 0 0 -110.84 0h-177.16a55.994 55.994 0 0 0 -110.84 0h-24.58v-16h8a16.021 16.021 0 0 0 16-16v-8a16.021 16.021 0 0 0 -16-16h-8v-8h464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136 296h192a8 8 0 0 0 8-8v-80a8 8 0 0 0 -8-8h-192a8 8 0 0 0 -8 8v80a8 8 0 0 0 8 8zm184-16h-80v-64h80zm-176-64h80v64h-80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 448h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.7ae009f8ebc2207c9d55eae5dff0c1ee.svg";
export { ForwardRef as ReactComponent };